/**
 * Generates URL from a object like File, Blob or MediaSource
 *
 * @param object a object which you need to convert into URL
 */

export default (object) => URL.createObjectURL(object);
